export default {
  SET_OVE_DETAIL(state, { oveDetail }) {
    state.oveDetail = oveDetail
  },
  SET_OVE_ACTIONS(state, { oveActions }) {
    state.oveActions = oveActions
  },
}
